module.exports = __webpack_public_path__ + "static/slide-awards-large-1137511e15787da36bd93ce71860bbf1.jpg";